import React, { useEffect, useState, Component } from 'react';
import { LandingPage } from './pages/LandingPage';
import { ReferralPage } from './pages/ReferralPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { SEO } from './components/SEO';
export function App() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  useEffect(() => {
    const handlePopState = () => {
      setCurrentPath(window.location.pathname);
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);
  // Routing logic
  let PageComponent = LandingPage;
  // Normalize path to handle language prefixes (en, ru, ua, pl)
  let normalizedPath = currentPath;
  if (currentPath.startsWith('/ru')) {
    normalizedPath = currentPath.substring(3);
  } else if (currentPath.startsWith('/ua')) {
    normalizedPath = currentPath.substring(3);
  } else if (currentPath.startsWith('/uk')) {
    // Handle legacy 'uk' prefix as 'ua'
    normalizedPath = currentPath.substring(3);
  } else if (currentPath.startsWith('/pl')) {
    normalizedPath = currentPath.substring(3);
  }
  if (normalizedPath === '') normalizedPath = '/';
  if (normalizedPath === '/referral') PageComponent = ReferralPage;else if (normalizedPath === '/privacy') PageComponent = PrivacyPage;else if (normalizedPath === '/terms') PageComponent = TermsPage;
  return <ThemeProvider data-id="element-0">
      <LanguageProvider data-id="element-1">
        <SEO data-id="element-2" />
        <PageComponent data-id="element-3" />
      </LanguageProvider>
    </ThemeProvider>;
}